export const STORE_CONSTANTS = {
    ALL_TASKS: {
        NAMESPACE: 'allTasks',
        ACTIONS: {
            WITH_NAMESPACE: {
				GET_TASKS_GENERAL: 'allTasks/getTasksGeneral',
                GET_CLUSTERS_FOR_MANAGER: 'allTasks/getClustersForManager',
                GET_ALL_STAFF_DAILY_SUMMARY: 'allTasks/getAllStaffDailySummary',
                GET_STAFF_DAILY_SUMMARY: 'allTasks/getStaffDailySummary',
                SET_SELECTED_TASK: 'allTasks/setSelectedTask',
            },
            WITHOUT_NAMESPACE: {
				GET_TASKS_GENERAL: 'getTasksGeneral',
                GET_CLUSTERS_FOR_MANAGER: 'getClustersForManager',
                GET_ALL_STAFF_DAILY_SUMMARY: 'getAllStaffDailySummary',
                GET_STAFF_DAILY_SUMMARY: 'getStaffDailySummary',
                SET_SELECTED_TASK: 'setSelectedTask',
            }
        },
        MUTATIONS: {
            WITH_NAMESPACE: {
                SET_TASKS: 'allTasks/setTasks',
                SET_SELECTED_TASK: 'allTasks/setSelectedTask',
                SET_IS_EXECUTING: 'allTasks/setIsExecuting'
            },
            WITHOUT_NAMESPACE: {
                SET_TASKS: 'setTasks',
                SET_SELECTED_TASK: 'setSelectedTask',
                SET_IS_EXECUTING: 'setIsExecuting'
            }
        }
    },
    ASSIGNMENT: {
        NAMESPACE: 'assignment',
        ACTIONS: {
            SET_DWELLING_ID: 'assignment/setDwellingId',
            SET_STAFF_ID: 'assignment/setStaffId',
            FETCH_GEO_JSON: 'assignment/fetchAssignmentGeoJson',
            FETCH_TABLE_JSON: 'assignment/fetchAssignmentTableJson',
        },
        MUTATIONS: {
            SET_DWELLING_ID: 'assignment/setDwellingId',
            SET_STAFF_ID: 'assignment/setStaffId',
            SET_GEO_JSON: 'assignment/setAssignmentGeoJson',
            SET_TABLE_JSON: 'assignment/setAssignmentTableJson',
            SET_IS_LOADING: 'assignment/setIsCaseAssignmentLoading',
            SET_SELECTED_CASE_IDS: 'assignment/setSelectedCaseIds',
            SET_REGION_STAFF: 'assignment/setRegionStaff'
        }
    },
    DAILY_TASKS: {
        NAMESPACE: 'dailyTasks',
        ACTIONS: {
            WITH_NAMESPACE: {
                SET_STAFF_DAILY_TASKS: 'dailyTasks/setStaffDailyTasks',
                GET_ALL_STAFF_TASKS_BY_QUERY: 'dailyTasks/queryAllStaffTasks',
                GET_TASKS_BY_STATUS: 'dailyTasks/getTasksByStatus',
                GET_TASKS_FOR_STAFF_AND_STATUS: 'dailyTasks/getTasksByStaffAndStatus',
                GET_ALL_STAFF_DAILY_SUMMARY: 'dailyTasks/getAllStaffDailySummary',
                GET_STAFF_DAILY_SUMMARY: 'dailyTasks/getStaffDailySummary',
                GET_CLUSTERS_FOR_MANAGER: 'dailyTasks/getClustersForManager',
                GET_TASKS_FOR_SPID: 'dailyTasks/getTasksForSpid',
                GET_STAFF_DAILY_LAST_GPS_TRACK: 'dailyTasks/getStaffDailyLastGpsTrack',
            },
            WITHOUT_NAMESPACE: {
                SET_STAFF_DAILY_TASKS: 'setStaffDailyTasks',
                GET_ALL_STAFF_TASKS_BY_QUERY: 'queryAllStaffTasks',
                GET_TASKS_BY_STATUS: 'getTasksByStatus',
                GET_TASKS_FOR_STAFF_AND_STATUS: 'getTasksByStaffAndStatus',
                GET_ALL_STAFF_DAILY_SUMMARY: 'getAllStaffDailySummary',
                GET_STAFF_DAILY_SUMMARY: 'getStaffDailySummary',
                GET_CLUSTERS_FOR_MANAGER: 'getClustersForManager',
                GET_TASKS_FOR_SPID: 'getTasksForSpid',
                GET_STAFF_DAILY_LAST_GPS_TRACK: 'getStaffDailyLastGpsTrack'
            }
        },
        MUTATIONS: {
            WITH_NAMESPACE: {
                SET_SUSPECT_TASK_COUNT: 'dailyTasks/setSuspectTaskCount',
                SET_TASK_COUNT: 'dailyTasks/setTaskCount',
                SET_STAFF_DAILY_TASKS: 'dailyTasks/setStaffDailyTasks',
                SET_STAFF_DAILY_TASKS_SUMMARY: 'dailyTasks/setStaffDailySummary',
                SET_STAFF_DAILY_LAST_GPS_TRACK: 'dailyTasks/setStaffDailyLastGpsTrack',
                CLEAR_STAFF_DAILY_INFO: 'dailyTasks/clearStaffDailyInfo',
                SET_IS_EXECUTING: 'dailyTasks/setIsExecuting',
            },
            WITHOUT_NAMESPACE: {
                SET_SUSPECT_TASK_COUNT: 'setSuspectTaskCount',
                SET_TASK_COUNT: 'setTaskCount',
                SET_STAFF_DAILY_TASKS: 'setStaffDailyTasks',
                SET_STAFF_DAILY_TASKS_SUMMARY: 'setStaffDailySummary',
                SET_STAFF_DAILY_LAST_GPS_TRACK: 'setStaffDailyLastGpsTrack',
                CLEAR_STAFF_DAILY_INFO: 'clearStaffDailyInfo',
                SET_IS_EXECUTING: 'setIsExecuting'
            }
        }
    },
    STUDY: {
        NAMESPACE: 'study',
        ACTIONS: {
            WITH_NAMESPACE: {
                SET_SELECTED_STUDY: 'study/setSelectedStudy',
                LOAD_STUDY_TASK_COUNTS: 'study/loadStudyTaskCounts'
            },
            WITHOUT_NAMESPACE: {
                SET_SELECTED_STUDY: 'setSelectedStudy',
                LOAD_STUDY_TASK_COUNTS: 'loadStudyTaskCounts'
            }
        },
        MUTATIONS: {
            WITH_NAMESPACE: {
                SET_SELECTED_STUDY_ID: 'study/setSelectedStudyId',
                SET_SELECTED_STUDY_STAFF: 'study/setSelectedStudyStaff',
                SET_SELECTED_STUDY_STAFF_MAP: 'study/setSelectedStudyStaffMap',
                SET_STUDY_TASK_COUNTS: 'study/setStudyTaskCounts',
                SET_STUDY_TASK_PERCENT: 'study/setStudyTaskPercent',
                SET_STUDY_GPS_DATA: 'study/setStudyGpsData'
            },
            WITHOUT_NAMESPACE: {
                SET_SELECTED_STUDY_ID: 'setSelectedStudyId',
                SET_SELECTED_STUDY_STAFF: 'setSelectedStudyStaff',
                SET_SELECTED_STUDY_STAFF_MAP: 'setSelectedStudyStaffMap',
                SET_STUDY_TASK_COUNTS: 'setStudyTaskCounts',
                SET_STUDY_TASK_PERCENT: 'setStudyTaskPercent',
                SET_STUDY_GPS_DATA: 'setStudyGpsData'
            }
        }
    },
    TRACKS: {
        NAMESPACE: 'tracks',
        ACTIONS: {
            WITH_NAMESPACE: {
				GET_TRACKS_AGGREGATE: 'tracks/getTrackAggregate',
                CLEAR_TRACKS_FOR_TASK: 'tracks/clearTaskTracks',
                GET_TRACKS_FOR_TASK: 'tracks/getTracksForTask',
                GET_CLUSTERS_FOR_DAY: 'tracks/getAllClustersForDay',
                GET_GPS_POINT_BY_ID: 'tracks/getGpsPointById',
                GET_CLUSTER_BY_ID: 'tracks/getClusterById',
                GET_ALL_TRACKS_FOR_DAY: 'tracks/getAllTracksforDay',
                GET_TRACKS_AND_CLUSTERS_FOR_DAY: 'tracks/getTracksAndClustersforDay',
                SET_SELECTED_POINT: 'tracks/setSelectedPoint',
                SET_SELECTED_POINT_ID: 'tracks/setSelectedPointId'
            },
            WITHOUT_NAMESPACE: {
				GET_TRACKS_AGGREGATE: 'getTrackAgrregate',
                CLEAR_TRACKS_FOR_TASK: 'clearTaskTracks',
                GET_TRACKS_FOR_TASK: 'getTracksForTask',
                GET_CLUSTERS_FOR_DAY: 'getAllClustersForDay',
                GET_GPS_POINT_BY_ID: 'getGpsPointById',
                GET_CLUSTER_BY_ID: 'getClusterById',
                GET_ALL_TRACKS_FOR_DAY: 'getAllTracksforDay',
                GET_TRACKS_AND_CLUSTERS_FOR_DAY: 'getTracksAndClustersforDay',
                SET_SELECTED_POINT: 'setSelectedPoint',
                SET_SELECTED_POINT_ID: 'setSelectedPointId'
            }
        },
        MUTATIONS: {
            WITH_NAMESPACE: {
                CLEAR_ALL_TRACKS: 'tracks/clearAllTracks',
                CLEAR_TRACKS_FOR_TASK: 'tracks/clearTaskTracks',
                SET_TASK_TRACKS: 'tracks/setTaskTracks',
                CLEAR_GPS_POINTS: 'tracks/clearGpsPoints',
                SET_GPS_POINT: 'tracks/setGpsPoint',
                CLEAR_CLUSTERS: 'tracks/clearClusters',
                SET_CLUSTER: 'tracks/setCluster',
                CLEAR_DAY_TRACKS: 'tracks/clearDayTracks',
                SET_CLIENT_EVENTS: 'tracks/setClientEvents',
                SET_DAY_TRACKS: 'tracks/setDayTracks',
                SET_SELECTED_POINT: 'tracks/setSelectedPoint',
                SET_SELECTED_POINT_ID: 'tracks/setSelectedPointId',
                SET_TASK_BY_ID: 'tracks/set',
                SET_TASKS_FEATURES: 'tracks/setTaskFeatures',
                SET_DAY_CLUSTERS_AND_TRACKS: 'tracks/setDayClusterAndTracks'
            },
            WITHOUT_NAMESPACE: {
                CLEAR_ALL_TRACKS: 'clearAllTracks',
                CLEAR_TRACKS_FOR_TASK: 'clearTaskTracks',
                SET_TASK_TRACKS: 'setTaskTracks',
                CLEAR_GPS_POINTS: 'clearGpsPoints',
                SET_GPS_POINT: 'setGpsPoint',
                CLEAR_CLUSTERS: 'clearClusters',
                SET_CLUSTER: 'setCluster',
                CLEAR_DAY_TRACKS: 'clearDayTracks',
                SET_CLIENT_EVENTS: 'setClientEvents',
                SET_DAY_TRACKS: 'setDayTracks',
                SET_SELECTED_POINT: 'setSelectedPoint',
                SET_SELECTED_POINT_ID: 'setSelectedPointId',
                SET_TASKS_FEATURES: 'setTaskFeatures',
                SET_DAY_CLUSTERS_AND_TRACKS: 'setDayClusterAndTracks'
            }
        }
    },
    VALIDATION: {
        NAMESPACE: 'validation',
        ACTIONS: {
            WITH_NAMESPACE: {
                CLEAR_MAP_DATA: 'validation/clearMapData',
                SET_POINT_INFO: 'validation/setPointInfo',
                SET_DAY_TRACKS_FOR_DAY: 'validation/setDayTracks',
                SET_CLUSTERS_FOR_DAY: 'validation/setDayClusters',
                SET_GPS_POINTS_FOR_DAY: 'validation/setDayGpsPoints',
                SET_DAY_TASKS: 'validation/setDayTasks',
                GET_EAGLE_DAY: 'validation/getEagleDay'
            },
            WITHOUT_NAMESPACE: {
                CLEAR_MAP_DATA: 'clearMapData',
                SET_POINT_INFO: 'setPointInfo',
                SET_DAY_TRACKS_FOR_DAY: 'setDayTracks',
                SET_CLUSTERS_FOR_DAY: 'setDayClusters',
                SET_GPS_POINTS_FOR_DAY: 'setDayGpsPoints',
                SET_DAY_TASKS: 'setDayTasks',
                GET_EAGLE_DAY: 'getEagleDay'
            }
        },
        MUTATIONS: {
            WITH_NAMESPACE: {
                CLEAR_POINT_INFO: 'validation/clearPointInfo',
                ADD_POINT_INFO: 'validation/addPointInfo',
                CLEAR_TASK_TRACKS: 'validation/clearTaskTracks',
                ADD_TASK_TRACK: 'validation/addTaskTrack',
                SET_MAP_MARKERS_DATA: 'validation/setMapMarkersData',
                SET_TASK_FEATURES: 'validation/setTaskFeatures',
                SET_IS_LOADING: 'validation/setIsValidationMapLoading',
                SET_POINT_OF_INTEREST: 'validation/setPointOfInterest'
            },
            WITHOUT_NAMESPACE: {
                CLEAR_POINT_INFO: 'clearPointInfo',
                ADD_POINT_INFO: 'addPointInfo',
                CLEAR_TASK_TRACKS: 'clearTaskTracks',
                ADD_TASK_TRACK: 'addTaskTrack',
                SET_MAP_MARKERS_DATA: 'setMapMarkersData',
                SET_TASK_FEATURES: 'setTaskFeatures',
                SET_IS_LOADING: 'setIsValidationMapLoading',
                SET_POINT_OF_INTEREST: 'setPointOfInterest'
            }
        }
    }
};
